import { createFeatureSelector } from '@ngrx/store';
import * as fromError from './error.reducer';

export const selectDispensaryState = createFeatureSelector<fromError.ErrorState>('error');
